import React from 'react';

function PreprocessModule({ onSubmit }) {
  const handleSubmit = () => {
    const method = document.getElementById('preMethod').value;
    const file = document.getElementById('preFile').files[0];
    if (!file) return alert("请上传蛋白结构文件");

    const form = new FormData();
    form.append('method', method);
    form.append('proteinFile', file);
    onSubmit('预处理', form, 'preprocess');
  };

  return (
    <div className="flex flex-col h-full">
      <select id="preMethod" className="form-select">
        <option value="pdbfixer">PDBFixer</option>
        <option value="rosetta">Rosetta</option>
      </select>
      <input type="file" id="preFile" className="form-input mt-2" />
      <div className="flex justify-center mt-auto pt-4">
        <button onClick={handleSubmit} className="btn-primary">提交任务</button>
      </div>
    </div>
  );
}

export default PreprocessModule;

